import debug from "debug";

const log = debug("teamform:bootstrap");

const prefix = "tf-bootstrap";

export const markBootstrap = (phase) => {
  if (!log.enabled) {
    return;
  }
  performance.mark(`${prefix}:${phase}`);
};

export const measureBootstrap = (name, startPhase, endPhase) => {
  if (!log.enabled) {
    return;
  }
  try {
    const entry = performance.measure(
      `${prefix}:${name}`,
      `${prefix}:${startPhase}`,
      `${prefix}:${endPhase}`
    );
    log("%s %sms", name, entry.duration.toFixed(1));
  } catch (error) {
    log("measure %s failed: %s", name, error.message);
  }
};

export const logBootstrapSummary = () => {
  if (!log.enabled) {
    return;
  }
  const entries = performance
    .getEntriesByType("measure")
    .filter((entry) => entry.name.startsWith(`${prefix}:`));
  if (!entries.length) {
    return;
  }
  log(
    "summary %O",
    Object.fromEntries(
      entries.map((entry) => [
        entry.name.replace(`${prefix}:`, ""),
        entry.duration,
      ])
    )
  );
};
